import classNames from '../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/bind.mjs';
import styles from './LayerTitle.module.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

const cx = classNames.bind(styles);
/**
 * @param alignLeft : 좌측정렬 케이스(타이틀, 본문)
 */
const LayerTitle = _ref => {
  let {
    title,
    children,
    count = '',
    alignLeft = false
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    className: cx('layer_title', {
      'align-left': alignLeft
    }),
    children: /*#__PURE__*/jsxs("div", {
      className: cx('title'),
      children: [/*#__PURE__*/jsx("h3", {
        children: title
      }), count && /*#__PURE__*/jsx("span", {
        className: cx('count'),
        children: count
      }), children]
    })
  });
};
var LayerTitle$1 = LayerTitle;

export { LayerTitle$1 as default };
